<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          GUIDEBOOK DOCUMENT
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9 class="pl-1">Guidebook Document</v-flex>
          <v-flex xs3 class="text-right">
            <v-icon @click="getDetail" title="refresh">refresh</v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5 pt-0">
            <v-layout row wrap>
              <v-flex xs12 class="pa-0">
                <v-flex xs12>
                  <v-row>
                    <v-flex xs12 class="pb-0">
                      <v-row>
                        <v-col cols="auto">
                          <label>Recent Document</label>
                        </v-col>
                        <v-col cols="auto" class="pt-3 px-0">
                          <label
                            >: {{ item == null ? '-' : item.file_name }}
                          </label>
                        </v-col>
                        <v-col cols="auto" class="pt-1" v-if="item">
                          <v-btn
                            icon
                            id="btn-download"
                            @click="downloadFile(item.file_name)"
                          >
                            <v-icon
                              color="primary"
                              style="font-size: 20px !important;"
                              >cloud_download</v-icon
                            >
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-flex>
                    <v-flex xs6 class="pt-0">
                      <uploader-vue
                        @afterComplete="uploadCompleteEnglish"
                        ref="docsenComponent"
                        title="Guidebook"
                        type=".docs"
                        @fileRemoved="cancelUploadEn"
                      ></uploader-vue>
                    </v-flex>
                  </v-row>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-card-actions class="text-right px-0">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="ml-4">
                <v-btn
                  id="btn-save"
                  rounded
                  color="blue darken-3"
                  class="white--text"
                  block
                  @click="save()"
                  :disabled="isDisable"
                >
                  Save
                </v-btn>
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';
import 'sweetalert2/src/sweetalert2.scss';
import UploaderVue from '../../../components/uploader';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    'progress-dialog': ProgressDialog,
    'uploader-vue': UploaderVue
  },
  data() {
    return {
      isDisable: true,
      item: {},
      document: {},
      loading: true,
      progressDialogLoading: true,
      search: '',
      baseUrl: process.env.VUE_APP_BASE_URL,
      breadcrumbs: [
        {
          text: 'Financial Portal',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Guidebook Document',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  watch: {
    document() {
      this.isDisable = Object.keys(this.document).length === 0 ? true : false;
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    uploadCompleteEnglish(obj) {
      var fileType = obj.file.name.split('.').pop();
      var fileTypes = ['docx', 'pdf'];
      if (fileTypes.includes(fileType)) {
        this.document = obj;
      } else {
        Swal.fire('Failed!', 'Format file must be .docs or .pdf.', 'error');
        this.$refs.docsenComponent.fileRemoved();
      }
    },
    async getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      await this.$store
        .dispatch('categoryPortal/getDoc')
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.item = data.data.guideline;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async save() {
      if (Object.keys(this.document).length === 0) {
        Swal.fire('Failed!', 'Please upload the document.', 'error');
      } else {
        this.saveConfirm();
      }
    },
    saveConfirm() {
      Swal.fire({
        title: '',
        text: 'Are you sure want to update this document?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        cancelButtonText: 'No, cancel it!'
      }).then(result => {
        if (result.value) {
          this.saveGuideline();
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your document data has been cancelled to update.',
            'error'
          );
        }
      });
    },
    saveGuideline() {
      this.progressDialogLoading = true;
      this.loading = true;
      let formData = new FormData();
      formData.append('document', this.document.file);
      this.$store
        .dispatch('categoryPortal/uploadDoc', formData)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            Swal.fire('Success!', data.message.text_en, 'success');
            this.$refs.docsenComponent.fileRemoved();
            this.document = {};
            this.getDetail();
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    cancelUploadEn() {
      this.document = {};
    },
    downloadFile(val) {
      let file = encodeURIComponent(val);
      window.open(
        this.baseUrl +
          '/v1/download/file?name=' +
          file +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>
